import { ButtonGroup, Fieldset, Form, Layout } from '@vwfs-bronson/bronson-react';
import { t } from 'i18next';
import React, { FunctionComponent } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { journeyDataActions, journeyDataSelectors } from '../../services/redux/features/journeyData.slice';
import { CustomerTypeEnum } from '../../types/customerTypeSelection';

export const CustomerTypeSelectionForm: FunctionComponent = () => {
  const customerType = useSelector(journeyDataSelectors.customerType);

  const dispatch = useDispatch();

  return (
    <Form>
      <Fieldset.Row>
        <Layout className="u-m-none">
          <Layout.Item default="1/1">
            <ButtonGroup buttonGroupName="formSelector" buttonGroupType="radio">
              <ButtonGroup.Item
                index="customerTypeSelection_1"
                readOnly
                buttonGroupItemIcon="semantic-user"
                checked={customerType === CustomerTypeEnum.consumer}
                testId="button_customer_consumer"
                onClick={() => {
                  dispatch(journeyDataActions.setCustomerType(CustomerTypeEnum.consumer));
                  // TODO: reset proper data if customer type was changed
                }}
              >
                {t('customerTypeSelectionPage:customerType.consumer')}
              </ButtonGroup.Item>
              <ButtonGroup.Item
                index="customerTypeSelection_2"
                readOnly
                buttonGroupItemIcon="briefcase"
                checked={customerType === CustomerTypeEnum.business}
                testId="button_customer_business"
                onClick={() => {
                  dispatch(journeyDataActions.setCustomerType(CustomerTypeEnum.business));

                  dispatch(journeyDataActions.setProductFamily());
                  dispatch(journeyDataActions.setVehicleType());
                }}
              >
                {t('customerTypeSelectionPage:customerType.business')}
              </ButtonGroup.Item>
            </ButtonGroup>
          </Layout.Item>
        </Layout>
      </Fieldset.Row>
    </Form>
  );
};
